import React from 'react';

import { Input, RadioCheck } from 'components';
import { useGetCurrentByIdQuery } from 'redux/slices/current/CurrentApi';

import PropTypes from 'prop-types';
import { hasPermission } from 'utils/helper';
import { permissions } from 'constant/permissions';
import { useSelector } from 'react-redux';
import { roleSettingsSelector } from 'redux/slices/app/authSlice';

const CurrentView = ({ company }) => {
  const { data: current } = useGetCurrentByIdQuery({
    id: company.value,
  });
  const roleSettingsInfo = useSelector(roleSettingsSelector);

  return (
    <div className="flex flex-col h-full w-full overflow-y-auto sm:gap-x-4 gap-y-2">
      <div className="flex w-40">
        <RadioCheck
          label="Şirket"
          type="radio"
          checkRowClassName={`${
            current?.data?.taxNumber ? 'font-semibold' : ''
          }`}
          checked={current?.data?.taxNumber ? true : false}
          disabled={true}
        />
        <RadioCheck
          label="Şahıs"
          type="radio"
          checkRowClassName={`${
            !current?.data?.taxNumber ? 'font-semibold' : ''
          }`}
          checked={!current?.data?.taxNumber ? true : false}
          disabled={true}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 space-x-2 w-full">
        <div className="space-y-2">
          <Input
            label="Şirket Adı"
            name="name"
            id="name"
            value={
              (!hasPermission(permissions.companyName, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.name) || ''
            }
            disabled={true}
          />
          <Input
            naxLength={200}
            label="Adı Soyadı"
            name="fullname"
            id="fullname"
            value={current?.data?.fullName || ''}
            disabled={true}
          />
          <Input
            label="E-Posta"
            name="email"
            id="email"
            value={
              (!hasPermission(permissions.email, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.email) || ''
            }
            disabled={true}
          />
          <Input
            label="Telefon Numarası"
            name="telephone"
            id="telephone"
            value={
              (!hasPermission(permissions.telephone, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.telephone) || ''
            }
            disabled={true}
          />
          <Input
            label="Cep Telefon Numarası"
            name="mobile"
            id="mobile"
            value={
              (!hasPermission(permissions.mobile, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.mobile) || ''
            }
            disabled={true}
          />
          {current?.data?.taxNumber ? (
            <>
              <Input
                maxLength={200}
                label="Vergi Dairesi"
                name="taxOffice"
                id="taxOffice"
                value={
                  (!hasPermission(
                    permissions.taxOffice,
                    'VIEW',
                    roleSettingsInfo
                  )
                    ? '********'
                    : current?.data?.taxOffice) || ''
                }
                disabled={true}
              />
              <Input
                label="Vergi Numarası"
                name="taxNumber"
                id="taxNumber"
                value={
                  (!hasPermission(
                    permissions.taxNumber,
                    'VIEW',
                    roleSettingsInfo
                  )
                    ? '********'
                    : current?.data?.taxNumber) || ''
                }
                disabled={true}
              />
            </>
          ) : (
            <Input
              label="Kimlik Numarası"
              name="identityNumber"
              id="identityNumber"
              value={
                (!hasPermission(
                  permissions.identityNumber,
                  'VIEW',
                  roleSettingsInfo
                )
                  ? '********'
                  : current?.data?.identityNumber) || ''
              }
              disabled={true}
            />
          )}
        </div>
        <div className="space-y-2">
          <Input
            label="Ülke"
            name="countryCode"
            id="countryCode"
            value={
              (!hasPermission(permissions.country, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.countryName) || ''
            }
            disabled={true}
          />
          <Input
            maxLength={10}
            label="Posta Kodu"
            name="zipCode"
            id="zipCode"
            value={
              (!hasPermission(permissions.zipCode, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.zipCode) || ''
            }
            disabled={true}
          />
          <Input
            label="Şehir"
            name="cityName"
            id="cityName"
            value={
              (!hasPermission(permissions.city, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.cityName) || ''
            }
            disabled={true}
          />
          <Input
            label="İlçe/Eyalet"
            name="districtName"
            id="districtName"
            value={
              (!hasPermission(
                permissions.districtName,
                'VIEW',
                roleSettingsInfo
              )
                ? '********'
                : current?.data?.districtName) || ''
            }
            disabled={true}
          />
          <Input
            label="Adres 1"
            name="address"
            id="address"
            value={
              (!hasPermission(permissions.address, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.address) || ''
            }
            disabled={true}
          />
          <Input
            label="Adres 2"
            name="address2"
            id="address2"
            value={
              (!hasPermission(permissions.address, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.address2) || ''
            }
            disabled={true}
          />
          <Input
            label="Adres 3"
            name="address3"
            id="address3"
            value={
              (!hasPermission(permissions.address, 'VIEW', roleSettingsInfo)
                ? '********'
                : current?.data?.address3) || ''
            }
            disabled={true}
          />
        </div>
      </div>
    </div>
  );
};

CurrentView.propTypes = {
  company: PropTypes.object,
};

export default CurrentView;
